import { put, take, call } from 'redux-saga/effects';
import { GET_EVENT_DROPDOWN_LEVELS_REQUEST } from './types';

import {
  getEventDropdownLevelError,
  getEventDropdownLevelSuccess,
} from '../../../reducers/eventsLevelsSlice';
import withLoading from '../../../sagas/loadingSaga';

export default function* eventsDropdownLevelsSaga(api) {
  while (true) {
    yield take(GET_EVENT_DROPDOWN_LEVELS_REQUEST);
    yield* withLoading(function* () {
      yield call(getEventsDropdownLevels, api);
    });
  }
}

function* getEventsDropdownLevels(api) {
  try {
    const eventDropdownLevelData = yield call(api.getEventsDropdownLevels);
    yield put(
      getEventDropdownLevelSuccess({
        eventDropdownLevelData: eventDropdownLevelData.data,
      }),
    );
  } catch (error) {
    yield put(getEventDropdownLevelError(error));
  }
}
